import { PRIVATE_MIRROR } from '../lib/feedContext';
import { useEffect, useState } from 'react';

import { parked } from './parked';

/**
 * Вкладка «лента 3.0»: по умолчанию как parked.lenta3.
 * `/feed3-standby.json` {on:true} возвращает её без нового выката app.
 */
export function useFeed3Nav(): boolean {
  const [on, setOn] = useState(!parked.lenta3);
  useEffect(() => {
    if (PRIVATE_MIRROR) return;
    const ac = new AbortController();
    fetch('/feed3-standby.json', { cache: 'no-store', signal: ac.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((body) => {
        if (body && typeof body.on === 'boolean') setOn(body.on);
      })
      .catch(() => {});
    return () => ac.abort();
  }, []);
  return on;
}
